export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/ComcastSMB/theme/components/scorecard/ScorecardView/ScorecardExport.js